import { CircularProgress } from '@mui/material';
import { useState } from 'react';
import { ActionButton } from '../../../components/Common';
import { useContract } from '../../../providers/ContractProvider';
import BulkAddressAction from './BulkAddressAction';

const Giftlist: React.FC = () => {
	const { gift } = useContract();
	const [saving, setSaving] = useState(false);

	const onClickSendGifts = (addressList: string[]) => () => {
		setSaving(true);
		gift(addressList)
			.then(() => {
				setSaving(false);
			})
			.catch(() => {
				setSaving(false);
			});
	};

	return (
		<BulkAddressAction
            title="Send Gift NFT's"
			renderActions={(addressList) => {
				return (
					<div>
						<ActionButton
							sx={{ marginTop: 1 }}
							variant="contained"
							onClick={onClickSendGifts(addressList)}
							disabled={saving}
						>
							{saving && <CircularProgress color="inherit" />}
							Send Gifts
						</ActionButton>
					</div>
				);
			}}
		/>
	);
};

export default Giftlist;
